module.exports = vendor_c1aa0b8a932d9677b6bb;